module.exports = __webpack_public_path__ + "img/icon-file-analytics.e14dd4ab.svg";